export type SystemConfigValueType = string | boolean | number | object;

export class SystemConfigValueDto {
	actual: SystemConfigValueType;
}
